// extracted by mini-css-extract-plugin
export default {"button":"primary-alt-small__button___GfY7D primary-small__button___76QBp primary__button___frFdc base__button___zT0JW"};